'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

var _styledComponentsReactiveGrid = require('styled-components-reactive-grid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  flex-wrap: nowrap;\n  padding: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Dropdown__SectionBody', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Row), styles);


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/Dropdown/SectionBody.js
// module id = 1649
// module chunks = 2